import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMyProject = (page: string, userid: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [projectList, setProjectList] = useState<ProjectListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.mypage.b2b1, [location.search, userid, page, searchParams.order, searchParams.reverse]],
    () =>
      fetcher.mypage.postProjectList1({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        pm: String(userid),  
        group: String(page),  
        order: searchParams.order ? String(searchParams.order) : '',
        reverse: searchParams.reverse ? String(searchParams.reverse) : '',        
      }),
    {
      enabled: (page === 'b2b1' || page === 'b2b2' || page === 'b2b3'), 
      onSuccess: (res: ProjectListResDto) => {
        switch (res.code) {
          case 200:
            setProjectList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { projectList, searchResult, refetch };
};

export default useMyProject;
